<p-drawer *ngIf="cardRequestDetailService.isCalculateViabilitySidebarVisible"
    [(visible)]="cardRequestDetailService.isCalculateViabilitySidebarVisible"
    position="right"
    styleClass="W1000"
    dismissible="false"
    closeOnEscape="false"
>

    <ng-template pTemplate="header">
        <div class="sidebar-header">
            <h6 class="sidebar-title">{{ 'REQUEST_DETAIL.CALCULATE_FEASIBILITY' | translate }}</h6>
        </div>
    </ng-template>
</p-drawer>

<app-loading [isLoading]="cardRequestDetailService.isLoading">
    <ng-container *ngIf="cardRequestDetailService.request !== null">
        <p-drawer
            [(visible)]="newCardRequestService.isFinishingOTP"
            *ngIf="newCardRequestService.isFinishingOTP"
            position="right"
            styleClass="W700"
            dismissible="false"
            closeOnEscape="false"
        >
            <ng-template pTemplate="header">
                <div class="sidebar-header">
                <h6 class="sidebar-title">{{ "MY_REQUESTS.CONTINUE" | translate }}</h6>
                </div>
            </ng-template>

            <ng-template pTemplate="content">
                <app-new-card-request [newRequestStatus]="newRequestStatus" [trustedConsentUrlBoxed]="consentBelenderUrl"
                [belenderStatus]="belenderStatus"></app-new-card-request>
            </ng-template>
        </p-drawer>

        <app-loading [isLoading]="cardRequestDetailService.isLoading">
            <ng-container>
                <app-card-request-detail-header />
                <div class="detail-body-buttons">
                    <div class="request-detail-buttons" *ngIf="cardRequestDetailService.request">
                        <button *ngIf="!hideCancelOTPButton()" class="outline-btn" (click)="confirmCancelOTP($event)">
                            <span class="material-symbols-outlined"> block </span>
                            {{ "REQUEST_DETAIL.CANCEL" | translate }}
                        </button>

                        <button class="outline-btn" (click)="cardRequestDetailService.refreshRequest(true)">
                            <span class=" material-symbols-outlined ico-list"> sync </span>

                            <div class="PR10 flex-column" style="display: flex; flex-direction: column; padding-right: 10px;">
                                {{ "MY_REQUESTS.SYNC" | translate }}
                                <span class="font9">{{ "MY_REQUESTS.LAST_TIME_SYNC" | translate }} {{ cardRequestDetailService.lastQueryHour | date:"HH:mm" }}</span>
                            </div>
                        </button>

                        <button *ngIf="utilsService.showQRButton(cardRequestDetailService.request.personQuery)" class="outline-btn" (click)="qrCodeDialog.open(cardRequestDetailService.request.personQuery)">
                            <span class="material-symbols-outlined"> qr_code </span>
                            {{ "SHOW_QR_CODE" | translate }}
                        </button>

                        <button *ngIf="!hideContinueOTPButton()" class="filled-btn" (click)="reopenOTPWidget()">
                            <span class="material-symbols-outlined"> autoplay </span>
                            {{ "REQUEST_DETAIL.CONTINUE_OTP" | translate }}
                        </button>
                        <!-- <button
                            *ngIf="!hideDownloadZip()"
                            [disabled]="isDownloadZipButtonDisabled"
                            class="filled-btn"
                            (click)="downloadZIP()"
                            pTooltip="{{ 'REQUEST_DETAIL.DOCUMENTS.DOWNLOAD_PLACEHOLDER' | translate }}"
                            tooltipPosition="left"
                        >
                            @if (isDownloadZipButtonDisabled){
                                <span class="material-symbols-outlined icon-spin">refresh</span>
                                {{ 'REQUEST_DETAIL.DOCUMENTS.DOWNLOADING' | translate }}
                            } @else {
                                <span class="material-symbols-outlined">download</span>
                                {{ 'REQUEST_DETAIL.DOCUMENTS.DOWNLOAD' | translate }}
                            }
                        </button> -->
                    </div>
                </div>

                <app-card-request-detail-documents *ngIf="cardRequestDetailService.request" />
                <router-outlet />
            </ng-container>
        </app-loading>
    </ng-container>
</app-loading>

<app-qr-code-dialog #qrCodeDialog position="center" [showId]="false" />
